import React from 'react';
import type { SVGProps } from 'react';

function OrthDownloadApp(
  props: SVGProps<SVGSVGElement> & {
    strokeColor: string;
    fillColor: string;
    shadowColor: string;
  }
) {
  const { strokeColor, fillColor, shadowColor } = props;
  return (
    <svg
      width='375'
      height='290'
      viewBox='0 0 375 290'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_6548_13594)'>
        <rect
          opacity='0.8'
          x='60'
          y='26'
          width='253'
          height='431'
          rx='52'
          stroke={strokeColor}
          stroke-width='4'
        />
        <path
          opacity='0.58'
          d='M228.37 216.69C201.209 223.925 173.045 223.663 146.66 216.655C125.092 210.925 112.24 188.626 118.06 167.026C125.389 139.792 139.663 115.42 158.849 95.9547C174.589 79.9891 200.415 79.9891 216.147 95.9547C235.342 115.428 249.616 139.81 256.945 167.061C262.756 188.652 249.93 210.951 228.37 216.69Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.54'
          d='M232.645 223.347C202.64 231.335 171.535 231.046 142.393 223.312C118.565 216.987 104.378 192.352 110.8 168.496C118.897 138.41 134.663 111.492 155.856 89.997C173.236 72.3604 201.767 72.3604 219.147 89.997C240.349 111.509 256.115 138.436 264.212 168.539C270.625 192.387 256.464 217.014 232.654 223.356L232.645 223.347Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.5'
          d='M236.912 230.005C204.071 238.753 170.026 238.438 138.119 229.97C112.039 223.05 96.5089 196.079 103.533 169.965C112.397 137.037 129.655 107.572 152.846 84.0394C171.876 64.7406 203.103 64.7319 222.123 84.0394C245.332 107.581 262.59 137.063 271.455 170.009C278.478 196.114 262.965 223.067 236.903 230.014L236.912 230.005Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.46'
          d='M241.187 236.663C205.51 246.163 168.516 245.822 133.852 236.619C105.521 229.095 88.6385 199.797 96.2816 171.426C105.914 135.646 124.655 103.636 149.862 78.0732C170.532 57.1035 204.455 57.1035 225.124 78.0732C250.34 103.653 269.09 135.681 278.713 171.479C286.339 199.841 269.491 229.13 241.178 236.671L241.187 236.663Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.42'
          d='M245.464 243.32C206.943 253.573 167.008 253.205 129.595 243.276C99.0052 235.158 80.7873 203.524 89.0324 172.896C99.4327 134.272 119.666 99.7163 146.871 72.1067C169.189 49.4661 205.808 49.4661 228.127 72.1067C255.349 99.7251 275.591 134.298 285.983 172.94C294.219 203.559 276.027 235.175 245.464 243.32Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.38'
          d='M249.729 249.977C208.372 260.991 165.488 260.598 125.318 249.925C92.4773 241.203 72.9157 207.242 81.7717 174.357C92.9397 132.89 114.665 95.7797 143.876 66.1404C167.835 41.8289 207.159 41.8289 231.118 66.1404C260.347 95.7884 282.081 132.916 293.24 174.409C302.079 207.286 282.552 241.229 249.729 249.969V249.977Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.34'
          d='M254.005 256.635C209.813 268.401 163.989 267.981 121.053 256.582C85.9522 247.265 65.0558 210.977 74.5137 175.827C86.4408 131.508 109.667 91.8604 140.885 60.1828C166.484 34.2091 208.513 34.2003 234.121 60.1828C265.348 91.8692 288.582 131.543 300.51 175.879C309.959 211.012 289.088 247.292 254.014 256.626L254.005 256.635Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.3'
          d='M258.271 263.292C211.235 275.82 162.47 275.365 116.777 263.24C79.4256 253.328 57.1768 214.704 67.2455 177.296C79.9404 130.134 104.658 87.9324 137.875 54.2252C165.123 26.5805 209.847 26.5805 237.096 54.2252C270.329 87.9499 295.056 130.169 307.742 177.358C317.802 214.748 295.588 253.354 258.263 263.292H258.271Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.26'
          d='M262.547 269.95C212.675 283.23 160.962 282.757 112.52 269.889C72.9172 259.373 49.3248 218.422 60.0042 178.757C73.4669 128.743 99.6682 84.0045 134.9 48.2589C163.788 18.9433 211.218 18.9433 240.106 48.2589C275.347 84.0132 301.565 128.787 315.019 178.819C325.681 218.466 302.133 259.399 262.547 269.941V269.95Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.22'
          d='M266.813 276.607C214.105 290.64 159.451 290.141 108.244 276.546C66.3814 265.436 41.454 222.149 52.7355 180.227C66.966 127.37 94.6593 80.0766 131.898 42.3014C162.435 11.3149 212.561 11.3149 243.098 42.3014C280.345 80.0941 308.056 127.414 322.278 180.297C333.551 222.202 308.658 265.471 266.822 276.607H266.813Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.18'
          d='M271.088 283.265C215.536 298.058 157.942 297.525 103.977 283.204C59.8636 271.49 33.5838 225.876 45.476 181.697C60.4744 125.996 89.6596 76.1573 128.896 36.3438C161.074 3.69511 213.904 3.68636 246.082 36.3438C285.336 76.1748 314.53 126.04 329.528 181.767C341.403 225.928 315.176 271.525 271.088 283.265Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.12'
          d='M275.356 289.922C216.968 305.468 156.425 304.908 99.7035 289.852C53.3387 277.543 25.7152 229.594 38.2182 183.158C53.9843 124.605 84.6615 72.2206 125.905 30.3774C159.732 -3.94221 215.249 -3.94221 249.076 30.3774C290.337 72.2381 321.023 124.658 336.78 183.237C349.266 229.655 321.695 277.578 275.356 289.922Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.08'
          d='M279.63 296.571C218.398 312.878 154.924 312.292 95.4363 296.501C46.8117 283.589 17.8533 233.312 30.9583 184.628C47.4835 123.232 79.6614 68.3014 122.903 24.4199C158.37 -11.5706 216.592 -11.5706 252.068 24.4199C295.336 68.3189 327.513 123.285 344.039 184.706C357.126 233.382 328.22 283.641 279.622 296.58L279.63 296.571Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          opacity='0.04'
          d='M283.906 303.229C219.838 320.288 153.415 319.675 91.1789 303.15C40.2945 289.651 9.99242 237.039 23.7082 186.089C41.0012 121.841 74.6624 64.3647 119.919 18.4536C157.035 -19.2078 217.954 -19.2078 255.07 18.4536C300.344 64.391 334.014 121.894 351.307 186.176C365.005 237.109 334.756 289.695 283.906 303.237V303.229Z'
          stroke={strokeColor}
          stroke-miterlimit='10'
        />
        <path
          d='M187.502 89.1047C148.955 89.1047 117.702 120.441 117.702 159.091C117.702 197.741 148.955 229.078 187.502 229.078C226.05 229.078 257.303 197.741 257.303 159.091C257.303 120.441 226.05 89.1047 187.502 89.1047ZM224.104 210.033C199.779 216.506 174.563 216.279 150.936 210.006C131.619 204.88 120.11 184.907 125.319 165.565C131.889 141.175 144.663 119.348 161.842 101.921C175.933 87.6263 199.063 87.6263 213.154 101.921C230.342 119.356 243.125 141.192 249.694 165.6C254.895 184.934 243.412 204.897 224.104 210.041V210.033Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_6548_13594'
          x1='269.262'
          y1='223'
          x2='267.601'
          y2='290.983'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.00445327' stopColor={shadowColor} stop-opacity='0' />
          <stop offset='0.492366' stopColor={shadowColor} stop-opacity='0.5' />
          <stop offset='0.865294' stopColor={shadowColor} />
        </linearGradient>
        <clipPath id='clip0_6548_13594'>
          <rect width='375' height='290' fill={shadowColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OrthDownloadApp;
